import { useLangue } from "@/lib/i18n";

/**
 * Le bouton qui bascule francais / darija.
 *
 * Il affiche TOUJOURS l'autre langue — celle vers laquelle on va, pas celle
 * ou l'on est. Un bouton qui affiche l'etat courant oblige a reflechir ;
 * celui-ci se lit comme une destination.
 *
 *   en francais   le bouton dit « ع »
 *   en darija     le bouton dit « FR »
 *
 * Il est volontairement gros : il se touche avec un pouce, debout, dans un
 * magasin — pas avec une souris.
 */
export default function BoutonLangue({
  sombre = false,
}: {
  /** Pour un fond fonce, ou le gris clair ne se verrait pas. */
  sombre?: boolean;
}) {
  const { langue, basculer } = useLangue();

  return (
    <button
      onClick={basculer}
      // Le libelle d'accessibilite reste dans la langue d'arrivee, comme le
      // bouton lui-meme.
      aria-label={langue === "fr" ? "بالعربية" : "En français"}
      title={langue === "fr" ? "بالعربية" : "En français"}
      className={`min-h-[40px] min-w-[52px] px-3 rounded-lg border-2 font-black text-sm leading-none flex items-center justify-center shrink-0 transition-colors ${
        sombre
          ? "border-white/30 text-white hover:bg-white/10"
          : "border-gray-300 text-gray-700 bg-white hover:bg-gray-50"
      }`}
    >
      {langue === "fr" ? (
        <span className="text-lg">ع</span>
      ) : (
        <span>FR</span>
      )}
    </button>
  );
}
